import { render, staticRenderFns } from "./CreateTaxPph22Import.vue?vue&type=template&id=c0b33282"
import script from "./CreateTaxPph22Import.vue?vue&type=script&lang=js"
export * from "./CreateTaxPph22Import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports